const downloadJsonFile = (data: unknown, filename: string) => {
  try {
    const formattedJson = JSON.stringify(data, null, 2)
    const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
      formattedJson,
    )}`
    const link = document.createElement('a')
    link.href = jsonString
    link.download = filename
    link.click()
  } catch (error) {
    console.error('Error downloading file:', error)
  }
}

export default downloadJsonFile
